module.exports = __webpack_public_path__ + "static/media/l_dot_17.e403b9a1.png";